import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Import global styles directly for Vite to process
import './styles.css';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
